import React from "react";
import "./styles.css";
import { useTutorialsContext } from "../TutorialsContext";

type TProps = {
    onAdvance: () => void;
    pending?: boolean;
}

const AdvanceButton = ({ onAdvance, pending = false }: TProps) => {
    const { disabled } = useTutorialsContext();
    const isDisabled = disabled || pending;

    return (
        <button
            className={`button_container ${isDisabled ? 'disabled' : ''}`}
            onClick={onAdvance}
            disabled={isDisabled}
        >
            <span className="button_text">{pending ? 'Please wait...' : 'Proceed'}</span>
        </button>
    );
}

export default React.memo(AdvanceButton);